// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"gj-z","badgeLink":"hj-z","category":"ij-z"};